import s from './SmallTutorGroupDayLesson.module.css'
import {modifiedDate} from '../middleware/dateControl';

export default function SmallTutorGroupDayLesson(prop) {
	let day = prop.day;
	return (<div className={s.container} >
		<div><p>Day ID -</p><p>{day.day_id}</p></div>
		<div><p>Title - </p><p>{day.title}</p></div>
		{(day.title !== day.description) && (<div><p>Description-</p><p>{day.description}</p></div>)}
		<div><p>Type - </p><p>{day.type}</p></div>
		<div><p>Item ID - </p><p>{day.item_ids[0]}</p></div>
		<div><p>Task Start Date - </p><p>{modifiedDate(day.start_time)}</p></div>
	</div>);
}